import type { FormControlLabelProps } from "@mui/material";
import type { ConfirmOptions } from "material-ui-confirm";
import type { ReactNode } from "react";

import { ConfirmProvider } from "material-ui-confirm";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface TranslatedConfirmProviderProps {
	children: ReactNode;
}

// Floating outlined labels sit ~9px above the field, so confirm text above a typed-keyword field needs room.
// The library supplies control and label itself; only the spacing is ours.
const SPACING_OPTIONS: ConfirmOptions = {
	acknowledgementFormControlLabelProps: { sx: { mt: 2 } } as FormControlLabelProps,
	confirmationKeywordTextFieldProps: { sx: { mt: 2 } }
};

// Calls that pass their own cancellationText/confirmationText still win; these only replace the library's English fallbacks.
const TranslatedConfirmProvider = ({ children }: TranslatedConfirmProviderProps) => {
	const { t } = useTranslation("common");
	const defaultOptions = useMemo<ConfirmOptions>(
		() => ({
			...SPACING_OPTIONS,
			cancellationText: t("actions.cancel"),
			confirmationText: t("actions.ok")
		}),
		[t]
	);

	return <ConfirmProvider defaultOptions={defaultOptions}>{children}</ConfirmProvider>;
};

export default TranslatedConfirmProvider;
